export const Assets = {
  PLACEHOLDERS: {
    PRODUCT_IMAGE: "/product-fallback.png",
    NO_DATA: "/product-fallback.png",
    ERROR: "/product-fallback.png",
    MISSING: "/product-fallback.png",
  },
  EXTERNAL: {
    UNSPLASH_SAMPLE_1: "https://images.unsplash.com/photo-1525547719571-a2d4ac8945e2?q=80&w=1964&auto=format&fit=crop",
    UNSPLASH_SAMPLE_2: "https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f",
    FTCDN_SAMPLE: "https://as1.ftcdn.net/jpg/15/36/10/02/1000_F_1536100223_zSjlvv2Sbu0QU56WTM9vUZo8NqAMa83u.webp",
    AMAZON_SAMPLE: "https://m.media-amazon.com/images/I/71-kz9nt2zL.jpg",
    GRAINY_NOISE: "https://grainy-gradients.vercel.app/noise.svg",
  },
};
